<template>
  <card card-body-classes="table-full-width" no-footer-line>
    <h4 slot="header" class="card-title">Activity Logs</h4>
    <div class="card-body">
      <b-row>
        <b-col>
          <b-form class="d-flex mb-2" inline @submit.prevent>
            <b-form-select
              v-model="pagination.perPage"
              aria-controls="recent-activity-table"
              :options="pagination.perPageOptions"
            >
            </b-form-select>
            <fg-input
              id="employees__searchQuery"
              class="ml-2"
              v-model="searchQuery"
              placeholder="Search..."
              aria-label="Search"
              aria-controls="recent-activity-table"
            ></fg-input>
          </b-form>
        </b-col>
      </b-row>
      <b-table
        :items="data"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="searchQuery"
        :per-page="pagination.perPage"
        :current-page="pagination.currentPage"
        striped
      >
        <template v-slot:cell(description)="data">
          <component
            :is="data.item | getEventComponentName"
            :event-log="data.item"
          >
          </component>
        </template>
      </b-table>
      <div class="d-flex justify-content-end">
        <n-pagination
          class="pagination-no-border"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
        />
      </div>
    </div>
  </card>
</template>

<script>
import { Pagination as NPagination } from "src/components";
import * as eventLogTypes from "@/helpers/eventLogTypes";
import RecentActivityTableDescriptionUserCreated from "./RecentActivityTableDescriptionUserCreated";
import RecentActivityTableDescriptionSubscriptionChanged from "./RecentActivityTableDescriptionSubscriptionChanged";
import RecentActivityTableDescriptionSubscriptionCancelled from "./RecentActivityTableDescriptionSubscriptionCancelled";
import RecentActivityTableDescriptionInvoiceIssued from "./RecentActivityTableDescriptionInvoiceIssued";
import RecentActivityTableDescriptionInvoicePaid from "./RecentActivityTableDescriptionInvoicePaid";
import RecentActivityTableDescriptionInvoiceMarkedOverdue from "./RecentActivityTableDescriptionInvoiceMarkedOverdue";
import RecentActivityTableDescriptionCreditNoteIssued from "./RecentActivityTableDescriptionCreditNoteIssued";
import RecentActivityTableDescriptionReminderSent from "./RecentActivityTableDescriptionReminderSent";
import RecentActivityTableDescriptionAccountStatementSent from "./RecentActivityTableDescriptionAccountStatementSent";
import RecentActivityTableDescriptionBookingCreated from "./RecentActivityTableDescriptionBookingCreated";
import RecentActivityTableDescriptionBookingCancelled from "./RecentActivityTableDescriptionBookingCancelled";
import RecentActivityTableDescriptionBookingRescheduled from "./RecentActivityTableDescriptionBookingRescheduled";
import RecentActivityTableDescriptionBookingPaid from "./RecentActivityTableDescriptionBookingPaid";
import RecentActivityTableDescriptionBookingRefunded from "./RecentActivityTableDescriptionBookingRefunded";
import RecentActivityTableDescriptionBookingPaymentReminderSent from "./RecentActivityTableDescriptionBookingPaymentReminderSent";

const eventComponentNames = {
  [eventLogTypes.INVOICE_ISSUED]:
    RecentActivityTableDescriptionInvoiceIssued.name,
  [eventLogTypes.INVOICE_PAID]: RecentActivityTableDescriptionInvoicePaid.name,
  [eventLogTypes.INVOICE_MARKED_OVERDUE]:
    RecentActivityTableDescriptionInvoiceMarkedOverdue.name,
  [eventLogTypes.USER_CREATED]: RecentActivityTableDescriptionUserCreated.name,
  [eventLogTypes.SUBSCRIPTION_CHANGED]:
    RecentActivityTableDescriptionSubscriptionChanged.name,
  [eventLogTypes.SUBSCRIPTION_CANCELLED]:
    RecentActivityTableDescriptionSubscriptionCancelled.name,
  [eventLogTypes.CREDIT_NOTE_ISSUED]:
    RecentActivityTableDescriptionCreditNoteIssued.name,
  [eventLogTypes.REMINDER_SENT]:
    RecentActivityTableDescriptionReminderSent.name,
  [eventLogTypes.ACCOUNT_STATEMENT_SENT]:
    RecentActivityTableDescriptionAccountStatementSent.name,
  [eventLogTypes.BOOKING_CREATED]:
    RecentActivityTableDescriptionBookingPaid.name,
  [eventLogTypes.BOOKING_CANCELLED]:
    RecentActivityTableDescriptionBookingCancelled.name,
  [eventLogTypes.BOOKING_RESCHEDULED]:
    RecentActivityTableDescriptionBookingRescheduled.name,
  [eventLogTypes.BOOKING_PAID]: RecentActivityTableDescriptionBookingPaid.name,
  [eventLogTypes.BOOKING_REFUNDED]:
    RecentActivityTableDescriptionBookingRefunded.name,
  [eventLogTypes.BOOKING_PAYMENT_REMINDER_SENT]:
    RecentActivityTableDescriptionBookingPaymentReminderSent.name
};

export default {
  components: {
    NPagination,
    RecentActivityTableDescriptionUserCreated,
    RecentActivityTableDescriptionSubscriptionChanged,
    RecentActivityTableDescriptionSubscriptionCancelled,
    RecentActivityTableDescriptionInvoiceIssued,
    RecentActivityTableDescriptionInvoicePaid,
    RecentActivityTableDescriptionInvoiceMarkedOverdue,
    RecentActivityTableDescriptionCreditNoteIssued,
    RecentActivityTableDescriptionReminderSent,
    RecentActivityTableDescriptionAccountStatementSent,
    RecentActivityTableDescriptionBookingCreated,
    RecentActivityTableDescriptionBookingCancelled,
    RecentActivityTableDescriptionBookingRescheduled,
    RecentActivityTableDescriptionBookingPaid,
    RecentActivityTableDescriptionBookingRefunded,
    RecentActivityTableDescriptionBookingPaymentReminderSent
  },
  filters: {
    getEventComponentName(eventLog) {
      if (!eventLog) return;
      return eventComponentNames[eventLog.type];
    }
  },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fields: [
        {
          key: "dateAndTime",
          label: "Date",
          sortable: true
        },
        {
          key: "description",
          label: "Description",
          sortable: false
        }
      ],
      searchQuery: null,
      sortBy: "dateAndTime",
      sortDesc: false,
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100],
        total: 0
      }
    };
  },

  computed: {
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.data.length;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    }
  }
};
</script>
